'use strict';

function LegendController($rootScope, $scope, objectMakerFactory, dataHolderFactory) {
  const self = this;

  this.configureTabs = function() {
		$scope.legendViewControl.tabClasses = ["",""];
	};

	$scope.getTabClass = function (tabNum) {
		return $scope.legendViewControl.tabClasses[tabNum];
	};

	$scope.getTabPaneClass = function (tabNum) {
		return "tab-pane " + $scope.legendViewControl.tabClasses[tabNum];
	};

	$scope.setActiveTab = function (tabNum) {
		self.configureTabs();
		$scope.legendViewControl.tabClasses[tabNum] = "active";
	};

	$scope.initLegendController = function(){
		$scope.legendViewControl= {};
		$scope.legendViewControl.tabClasses = [];
		self.configureTabs();
		$scope.legendViewControl.tabClasses[1] = "active";
		$scope.legendViewControl.typesWork = dataHolderFactory.getSavedFilterOptions().categories;
		$scope.legendViewControl.status = dataHolderFactory.getSavedFilterOptions().uniqueStatus;
	};
}

LegendController.$inject=['$rootScope', '$scope', 'objectMakerFactory', 'dataHolderFactory'];
export default LegendController


// WEBPACK FOOTER //
// ./src/app/scripts/controllers/legendController.js